// extracted by mini-css-extract-plugin
module.exports = {"btn_cloud":"FJCloudFreeButton_btn_cloud__2n36Y"};